

import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import config from "../config/config";
import {
  checkUserPermission,
  updateUserPermission,
  updateUserDetails,
  getUserPermissionData,
  getUserData,
} from "../common/UserPermission";

const PrivateRoute = ({ children, permission }) => {
  const navigate = useNavigate();
  const [status, setStatus] = useState(false);

  const handleSubmit = () => {
    let userPermissionData = getUserPermissionData();
    let userData = getUserData();


    //  if (
    //   !checkUserPermission(permission))
    //     {
    //     navigate("/error403");
    //   } else {
    //     // set permission status
    //     setStatus(true);
    //   }
    const token = localStorage.getItem("Token");
    const loginUserId = localStorage.getItem("ID");

    console.log("CALL PRIVATE ROUTE");

    axios
      .get(
        `${config.authenticationBaseUrl}/users/userpermissionbyuserid?id=${loginUserId}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        let userPermission = res.data.ResponseData.UserPermissions;
        let userDetails = res.data.ResponseData.UserDetails[0];

        updateUserPermission(userPermission);
        updateUserDetails(userDetails);

        localStorage.setItem("UserRegisterId", userDetails.RegisterId);
        localStorage.setItem("MasterRegisterId", userDetails.MasterRegisterId);

        if (
          userDetails &&
          userDetails.RoleType &&
          (userDetails.RoleType.toUpperCase() == "SUPERADMIN" || userDetails.RoleType.toUpperCase() == "ADMIN")
        ) {
          setStatus(true);
        } else {
          if (
            userPermission !== "" &&
            !userPermission.some((item) => item.Name === permission)
          ) {
            navigate("/error403");
          } else {
            // set permission status
            setStatus(true);
          }
        }

      })
      .catch((err) => {
        console.log(err);
        localStorage.clear()
        navigate("/login");
      });
    // if (userData.RoleType === undefined || userPermissionData.length === 0) {
     
    // } else {
    //   if (
    //     userData &&
    //     userData.RoleType &&
    //     userData.RoleType.toUpperCase() == "SUPERADMIN"
    //   ) {
    //     setStatus(true);
    //   } else {
    //     if (
    //       userPermissionData !== "" &&
    //       !userPermissionData.some((item) => item.Name === permission)
    //     ) {
    //       navigate("/error403");
    //     } else {
    //       // set permission status
    //       setStatus(true);
    //     }
    //   }
    // }
  };

  useEffect(() => {
    handleSubmit();
  });

  // if user has permission
  if (status === true) {
    return children;
  }
};

export default PrivateRoute;

// import { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { checkUserPermission, getUserPermission } from "../common/UserPermission";

// const PrivateRoute = ({ children, permission }) => {
//   const navigate = useNavigate();
//   const [status, setStatus] = useState(false);
//   const [isLoading, setIsLoading] = useState(true);

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         await getUserPermission();
//         setIsLoading(false);
//       } catch (error) {
//         //console.log("Error Admin 1",error);
//         navigate("/error403"); // redirect to 403 error page if there's an error fetching user permission
//       }
//     };
//     fetchData();
//   }, [navigate]); // re-run effect if navigate changes

//   useEffect(() => {
//     const handleSubmit = () => {
//       if (!checkUserPermission(permission)) {
//         navigate("/error403");
//       } else {
//         setStatus(true);
//       }
//     };

//     if (!isLoading) { // wait for isLoading to be false before checking user permission
//       handleSubmit();
//     }
//   }, [isLoading, navigate, permission]);

//   if (isLoading) {
//     return <div>Loading...</div>;
//   }

//   if (status === true) {
//     return children;
//   }

//   return null;
// };

// export default PrivateRoute;

// import axios from "axios";
// import { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import config from "../config/config";
// import {
//   checkUserPermission,
//   updateUserPermission,
//   updateUserDetails,
//   getUserPermissionData,
//   getUserData,
// } from "../common/UserPermission";

// const PrivateRoute = ({ children, permission }) => {
//   const navigate = useNavigate();
//   const [status, setStatus] = useState(false);

//   const handleSubmit = () => {
//     let userPermissionData = getUserPermissionData();
//     let userData = getUserData();


//     //  if (
//     //   !checkUserPermission(permission))
//     //     {
//     //     navigate("/error403");
//     //   } else {
//     //     // set permission status
//     //     setStatus(true);
//     //   }

//     if (userData.RoleType === undefined || userPermissionData.length === 0) {
//       const token = localStorage.getItem("Token");
//       const loginUserId = localStorage.getItem("ID");

//       console.log("CALL PRIVATE ROUTE");

//       axios
//         .get(
//           `${config.authenticationBaseUrl}/users/userpermissionbyuserid?id=${loginUserId}`,
//           {
//             headers: {
//               "Content-Type": "application/json;charset=UTF-8",
//               Authorization: token,
//             },
//           }
//         )
//         .then((res) => {
//           let userPermission = res.data.ResponseData.UserPermissions;
//           let userDetails = res.data.ResponseData.UserDetails[0];

//           updateUserPermission(userPermission);
//           updateUserDetails(userDetails);

//           if (
//             userDetails &&
//             userDetails.RoleType &&
//             userDetails.RoleType.toUpperCase() == "SUPERADMIN"
//           ) {
//             setStatus(true);
//           } else {
//             if (
//               userPermission !== "" &&
//               !userPermission.some((item) => item.Name === permission)
//             ) {
//               navigate("/error403");
//             } else {
//               // set permission status
//               setStatus(true);
//             }
//           }

//         })
//         .catch((err) => {
//           console.log(err);
//           localStorage.clear()
//           navigate("/login");
//         });
//     } else {
//       if (
//         userData &&
//         userData.RoleType &&
//         userData.RoleType.toUpperCase() == "SUPERADMIN"
//       ) {
//         setStatus(true);
//       } else {
//         if (
//           userPermissionData !== "" &&
//           !userPermissionData.some((item) => item.Name === permission)
//         ) {
//           navigate("/error403");
//         } else {
//           // set permission status
//           setStatus(true);
//         }
//       }
//     }
//   };

//   useEffect(() => {
//     handleSubmit();
//   });

//   // if user has permission
//   if (status === true) {
//     return children;
//   }
// };

// export default PrivateRoute;

// // import { useEffect, useState } from "react";
// // import { useNavigate } from "react-router-dom";
// // import { checkUserPermission, getUserPermission } from "../common/UserPermission";

// // const PrivateRoute = ({ children, permission }) => {
// //   const navigate = useNavigate();
// //   const [status, setStatus] = useState(false);
// //   const [isLoading, setIsLoading] = useState(true);

// //   useEffect(() => {
// //     const fetchData = async () => {
// //       try {
// //         await getUserPermission();
// //         setIsLoading(false);
// //       } catch (error) {
// //         //console.log("Error Admin 1",error);
// //         navigate("/error403"); // redirect to 403 error page if there's an error fetching user permission
// //       }
// //     };
// //     fetchData();
// //   }, [navigate]); // re-run effect if navigate changes

// //   useEffect(() => {
// //     const handleSubmit = () => {
// //       if (!checkUserPermission(permission)) {
// //         navigate("/error403");
// //       } else {
// //         setStatus(true);
// //       }
// //     };

// //     if (!isLoading) { // wait for isLoading to be false before checking user permission
// //       handleSubmit();
// //     }
// //   }, [isLoading, navigate, permission]);

// //   if (isLoading) {
// //     return <div>Loading...</div>;
// //   }

// //   if (status === true) {
// //     return children;
// //   }

// //   return null;
// // };

// // export default PrivateRoute;
